import { render, staticRenderFns } from "./Tixreview.vue?vue&type=template&id=2276b776&scoped=true&"
import script from "./Tixreview.vue?vue&type=script&lang=js&"
export * from "./Tixreview.vue?vue&type=script&lang=js&"
import style0 from "./Tixreview.vue?vue&type=style&index=0&id=2276b776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2276b776",
  null
  
)

export default component.exports